export default {
    fontFamily: "'soleil', sans-serif",
};
